import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client.fsps(fspId).otps(id).otpAuditLogs.query(formatQueryParams(params));
